import { format } from "date-fns";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { Dialog } from "primereact/dialog";
import { useEffect, useRef, useState } from "react";
import { FaCheck, FaChevronCircleDown, FaInfoCircle, FaLink } from "react-icons/fa";
import { useNegotiation } from "../contexts/NegotiationContext";
import { usePrivate } from "../contexts/PrivateInfoContext";
import { carregaNegociacaoCobrancas } from "../services/requests/getChargesInfo";
import { formatCurrency } from "../utils/FormatCurrency";
import { ColunaBoletoBody } from "./ColumnBodys";

function DialogNegociadas({ close }) {
  const { negociadas } = usePrivate();
  const { setCartaoLinkID, setMostraCartaoCreditoLinkDialog } = useNegotiation();
  const [mostraNegociacaoDetalhesDialog, setMostraNegociacaoDetalhesDialog] = useState(false);
  const [negociacaoDetalhes, setNegociacaoDetalhes] = useState([]);
  const negociacao_id = useRef(null);
  //console.log(negociadas);

  useEffect(() => {
    async function getNegotiatioDetails() {
      try {
        const data_negociacao = await carregaNegociacaoCobrancas(negociacao_id.current);
        //console.log(data_negociacao);
        setNegociacaoDetalhes(data_negociacao.cobrancasNegociadas);
      } catch (error) {
        console.log(error);
      }
    }
    getNegotiatioDetails();
  }, [mostraNegociacaoDetalhesDialog]);

  function mostraDetalhes(e) {
    negociacao_id.current = e;
    setMostraNegociacaoDetalhesDialog(true);
  }

  function abrirLink(cartao_id_cobranca) {
    console.log(cartao_id_cobranca);
    setCartaoLinkID(cartao_id_cobranca);
    window.open(`https://gateway.fixpay.com.br/payment/${cartao_id_cobranca}`, "_blank", "noopener, noreferrer");
    setMostraCartaoCreditoLinkDialog(true);
  }

  return (
    <div className="boletosDialog">
      <Dialog
        visible
        className="boletosDialog max-[760px]:!w-full max-[760px]:!max-w-full"
        onHide={() => close()}
        style={{
          minHeigth: "30vw",
          maxWidth: "50vw",
          textAlign: "center",
          //borderRadius: '30px',
          //padding: '10px'
        }}
        draggable={false}
        header="Negociações Anteriores"
      >
        <div>
          {negociadas.map((negociada, index) => (
            <details
              className="border-2 border-green-300 p-[1vh] mb-[1vh] rounded-md 
                hover:bg-green-100"
              open={index === 0}
            >
              <summary
                className="font-lato-bold flex justify-between gap-[min(2vh,1.2rem)] cursor-pointer
                    p-[min(1vh,0.6rem)] "
              >
                <div className="grid text-left min-w-0 [&_h6]:!text-[min(2.4vh,1.45rem)] max-[500px]:[&_h6]:!text-[0.85rem] max-[500px]:[&_h6]:!leading-tight max-[300px]:[&_h6]:!text-[0.7rem]">
                  <h6>{negociada.cobranca_descricao}</h6>
                  <h6>Valor Negociação: {formatCurrency(negociada.cobranca_total_pagamento)}</h6>
                  <h6>Valor Pago: {formatCurrency(negociada.valor_pago)}</h6>
                </div>
                <div className="grid mb-[1vh] shrink-0" onClick={() => mostraDetalhes(negociada.cobranca_id)}>
                  <FaInfoCircle className="text-[min(5vh,3rem)] max-[500px]:text-[2rem] max-[300px]:text-[1.5rem] self-center text-yellow-500" />
                </div>
                <div className="grid mb-[1vh] shrink-0">
                  <FaChevronCircleDown className="text-[min(5vh,3rem)] max-[500px]:text-[2rem] max-[300px]:text-[1.5rem] self-center text-green-500 detailsIcon" />
                </div>
              </summary>
              <div className="border-t-2 w-full h-[1vh] border-green-500"></div>
              {/* <h6 className='font-lato-bold'>Débitos</h6>
                    <DataTable
                    value={negociada.cobrancasNegociadas}
                    lazy
                    //header="Cobranças"
                    className='boletosDialog w-full py-[2vh]'
                    responsiveLayout="stack"
                    breakpoint='900px'
                    scrollHeight='30vh'
                    scrollable={true}
                    >
                        <Column headerClassName='whitespace-nowrap' header='Descrição Da Cobrança' field='v_cobranca_descricao' />
                        <Column headerClassName='whitespace-nowrap' header='Data Vencimento' field='data_vencimento_primeiro_boleto' body={(rowData)=>{return format(new Date(rowData.v_data_vencimento_primeiro_boleto),'dd/MM/yyyy')}} />
                        <Column headerClassName='whitespace-nowrap' header='Valor Original' field='cobranca_valor' body={(rowData)=>{return formatCurrency(rowData.v_cobranca_valor)}} />
                    </DataTable> */}
              {negociada.boletos.length > 0 && (
                <>
                  <div className="w-full max-h-[30vh] overflow-y-auto overflow-x-hidden">
                    <div className="sticky top-0 z-10 bg-[rgb(218,255,218)]">
                      <h6 className="font-lato-bold !text-[min(2.4vh,1.45rem)]">Boletos</h6>
                      <h6 className="font-lato-bold hidden md:block absolute right-0 top-0 w-[min(10vh,4rem)] text-center text-[min(1.6vh,0.8rem)] leading-tight">
                        Cód. barras
                      </h6>
                    </div>
                    <ColunaBoletoBody rowData={negociada.boletos} />
                  </div>
                </>
              )}
              {negociada.cartaos.length > 0 && (
                <>
                  <h6 className="font-lato-bold">Cartão</h6>
                  {negociada?.cartaos[0]?.cartao_status === "paid" ? (
                    <div className="flex justify-center mt-2">
                      <span className="flex gap-4 items-center justify-center p-3 bg-green-700 text-white font-lato-bold rounded-lg">
                        <FaCheck />
                        <h6>PAGO</h6>
                      </span>
                    </div>
                  ) : (
                    <div className="flex justify-center mt-2">
                      <button
                        className="bg-[#001d74] w-auto h-[6vh] text-slate-50 p-3
                        hover:bg-gradient-to-b hover:from-[#0000ff] hover:to-[#0040ff] 
                        hover:shadow-[1.5px_1.5px_5px_5px_#4300fa85] transition duration-300
                        disabled:hover:from-[#001d74]/0 disabled:hover:to-[#001d74]/0 disabled:hover:shadow-none
                        text-[2.5vh] font-lato font-bold disabled:bg-[#001d74]/70 rounded-md
                        flex justify-between items-center gap-2"
                        onClick={() => abrirLink(negociada?.cartaos[0]?.cartao_id_cobranca)}
                        key={negociada?.cartaos[0]?.cobranca_id}
                        //disabled={!done}
                      >
                        <FaLink />
                        Abrir link de pagamento
                      </button>
                    </div>
                  )}
                </>
              )}
              {negociada.boletos.length > 0 && negociada.cartaos.length > 0 && (
                <>
                  <h6 className="font-lato-bold">A negociação foi cancelada e os boletos estão indisponíveis</h6>
                </>
              )}
            </details>
          ))}
          <Dialog
            visible={mostraNegociacaoDetalhesDialog}
            className="boletosDialog text-center w-full"
            header="Detalhes da Negociação"
            onHide={() => setMostraNegociacaoDetalhesDialog(false)}
            style={{
              heigth: window.innerHeight > 900 ? "50vh" : "90vh",
              width: window.innerWidth > 900 ? "60vw" : "100vw",
              maxWidth: "100vw",
            }}
          >
            <div className="boletosDialog whitespace-nowrap w-full">
              {negociacaoDetalhes.length > 0 && (
                <DataTable
                  value={negociacaoDetalhes}
                  lazy
                  className="boletosDialog w-full"
                  responsiveLayout="stack"
                  breakpoint="900px"
                >
                  <Column header="Descrição Da Cobrança" field="v_cobranca_descricao" />
                  <Column
                    header="Data Vencimento"
                    field="v_data_vencimento_primeiro_boleto"
                    body={(rowData) => {
                      return format(new Date(rowData.v_data_vencimento_primeiro_boleto), "dd/MM/yyyy");
                    }}
                  />
                  <Column
                    header="Valor Original"
                    field="v_cobranca_valor"
                    body={(rowData) => {
                      return formatCurrency(rowData.v_cobranca_valor);
                    }}
                  />
                </DataTable>
              )}
            </div>
          </Dialog>
        </div>
      </Dialog>
    </div>
  );
}

export default DialogNegociadas;